<template>
  <PinBtn
    v-if="!hide_pin_controls"
    :item="item"
    :myKey="myKey"></PinBtn>
  <PinAutoRefreshBtn
    v-if="!currentTemplate && !hide_activate_controls"
    :item="item"
    :myKey="myKey" />
  <v-card
    v-if="deluge?.pinned_svars"
    :style="`opacity: ${opaqueMode ? 1 : 0.5}`"
    flat
    class="mb-2"
    style="width: 100%; background: var(--v-field-color)">
    <v-card-subtitle
      style="justify-content: start; align-items: start; display: flex"
      class="pb-0 pt-2">
      {{ item.label }}
      <div
        style="opacity: 0.6"
        v-if="!realtime_mode"
        class="ml-2">
        (Auto Trigger)
      </div>
    </v-card-subtitle>
    <div class="px-2">
      <v-switch
        v-if="!realtime_mode"
        :disabled="readOnlyMode"
        v-model="item.value"
        class="py-0 px-2 mb-2 toggle-class"
        hide-details
        color="primary"
        inset></v-switch>
      <v-btn
        v-else
        class="ma-3"
        :disabled="readOnlyMode"
        hide-details
        @click="sendTrigger()"
        color="primary"
        inset>
        <v-icon>mdi-play</v-icon>
      </v-btn>
    </div>
  </v-card>
  <div style="display: flex">
    <v-icon
      v-if="currentTemplate?.src_scene_data?.[myKey]"
      variant="flat"
      class="ml-3 refresh-button"
      style="height: 56px !important"
      @click="handleUserIntent(myKey, originLevel)"
      :style="unLockedMode ? 'opacity: 0.3' : 'opacity: 0.7'"
      :title="
        unLockedMode
          ? 'Value inherits from Template or Source'
          : 'Value locked. (Will not inherit from Template or Source)'
      "
      :icon="
        unLockedMode ? 'mdi-lock-open-variant-outline' : 'mdi-lock-outline'
      "></v-icon>

    <!-- <PinSendNowBtn
      v-if="!currentTemplate"
      :item="item"
      :myKey="myKey" /> -->
  </div>
</template>
<script setup>
import { ref, watch } from 'vue';
import { deluge } from '@/stores/deluge.js';

import PinBtn from './PinBtn.vue';
import PinAutoRefreshBtn from './PinAutoRefreshBtn.vue';
import PinSendNowBtn from './PinSendNowBtn.vue';
import { isOpaque } from './utils.js';
import { computed, defineProps } from 'vue';
const opaqueMode = computed(() => {
  return isOpaque(deluge, props);
});
import { inheritanceHandler } from '../../../utils/inheritanceHandler';
const props = defineProps([
  'currentTemplate',
  'resetFunc',
  'originLevel',
  'item',
  'myKey',
  'hideicons',
  'realtime_mode',
  'hide_pin_controls',
  'hide_activate_controls',
  'readOnlyMode',
]);

const unLockedMode = ref(props.item.keyInherited);

const emit = defineEmits(['valueChanged']);

function handleUserIntent(myKey, originLevel) {
  if (props.readOnlyMode) return;
  unLockedMode.value = !unLockedMode.value;
  props.item.userIntent = unLockedMode.value === true ? 'remove' : 'keep';
  if (unLockedMode.value === true) {
    props.resetFunc(myKey, originLevel);
  }
}

function sendTrigger() {
  emit('valueChanged', [props.myKey, true]);
}

watch(
  () => props.item.value,
  () => {
    inheritanceHandler(props.item);
  },
  // It's required to run this watcher immediately
  // else the value will change before the handler tracks the initial value
  { immediate: true }
);
</script>
<style scoped>
.template-pop-up > .v-overlay__content > .v-card .px-3,
.template-pop-up > .v-overlay__content > .v-card .px-2 {
  height: 95% !important;
}
</style>
